"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TabContent = function TabContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      selectedIndex = _ref.selectedIndex,
      renderActiveOnly = _ref.renderActiveOnly;
  var classes = (0, _classnames.default)('TabContent', className);
  return _react.default.createElement("div", {
    className: classes
  }, _react.Children.map(children, function (panel, i) {
    if (panel) {
      if (renderActiveOnly) {
        if (selectedIndex === i) {
          return (0, _react.cloneElement)(panel, {
            active: true,
            index: i
          });
        } else {
          return null;
        }
      } else {
        return (0, _react.cloneElement)(panel, {
          active: selectedIndex === i,
          index: i
        });
      }
    }
  }));
};

TabContent.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** Children should only be made up of TabPanel components or a false boolean value when a condition to render the TabPanel is false. */
  children: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool])).isRequired,

  /** The selected tab index. Automatically passed from Tabs, do not set manually. */
  selectedIndex: _propTypes.default.number,

  /** Whether to only render the active tab's content or all content for every tab in the DOM. */
  renderActiveOnly: _propTypes.default.bool
};
var _default = TabContent;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabContent, "TabContent", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/TabContent.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/TabContent.jsx");
  leaveModule(module);
})();

;